import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=6a447560&scoped=true&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"
import style0 from "./goods.vue?vue&type=style&index=0&lang=css&"
import style1 from "./goods.vue?vue&type=style&index=1&id=6a447560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a447560",
  null
  
)

export default component.exports